export default __webpack_public_path__ + "static/media/place-image-mobile.2286cbee.png";